<template>
  <div>
    <div class="row"
      v-for="(experience, index) in addIndexToExperiences()"
      :key="index"
    >
      <div class="col-md-4" v-for="(exp, index2) in experience" :key="index + '' + index2">
        <div v-if="exp">
          <b-form-checkbox
            :id="'checkbox-' + exp.id"
            v-model="$store.state.experiencesSelected"
            :name="'checkbox-' + exp.id"
            :value="exp.id"
          >
            Experiencia número {{ exp.index }} / {{ exp.code }}
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../api/index";
import Partition from "../../../helpers/partition";
export default {
  name: "Reports",
  data() {
    return {
      status: false
    };
  },
  methods: {
    getExperiences: api.getExperiences,
    Partition: Partition,
    addIndexToExperiences() {
      this.experiences.map((exp, index) => {
        exp.index = index + 1;
        exp.status = false;
      });
      return this.Partition(this.experiences, 3);
    }
  },
  mounted() {
    this.getExperiences();
  },
  computed: {
    experiences() {
      return this.$store.state.experiences;
    }
  }
};
</script>

<style scoped>
.container-title {
  border-bottom: 1px solid #aaa;
}

.title {
  font-weight: bold;
  font-size: 17px;
}
</style>
